module.exports = __webpack_public_path__ + "img/Ripple-1s-200px.35b1a8cf.svg";